<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <clipPath id="master_svg0_2315_16033">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
      <clipPath id="master_svg1_2315_15931">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
    </defs>
    <g clip-path="url(#master_svg0_2315_16033)">
      <g clip-path="url(#master_svg1_2315_15931)">
        <g>
          <g>
            <path
              d="M9.699997991409301,12.999958038330078L6.489997991409302,12.999958038330078C6.430917991409302,12.994058038330078,6.3796979914093015,13.040658038330077,6.379997991409302,13.099958038330078L6.379997991409302,13.529958038330077C6.379997991409302,13.767458038330078,6.572517991409302,13.959958038330079,6.809997991409302,13.959958038330079L9.3799979914093,13.959958038330079C9.617487991409302,13.959958038330079,9.8099979914093,13.767458038330078,9.8099979914093,13.529958038330077L9.8099979914093,13.099958038330078C9.810297991409302,13.040658038330077,9.759087991409302,12.994058038330078,9.699997991409301,12.999958038330078ZM8.089997991409302,2.000000000030078C6.098317991409302,1.995831128330078,4.353381991409302,3.332998038330078,3.8394679914093017,5.2572480383300775C3.325552991409302,7.1814880383300785,4.1714449914093015,9.210598038330078,5.899997991409302,10.199998038330078L5.899997991409302,11.749998038330078C5.899997991409302,11.987478038330078,6.092517991409302,12.179958038330078,6.329997991409302,12.179958038330078L9.859997991409301,12.179958038330078C10.097477991409303,12.179958038330078,10.289997991409301,11.987478038330078,10.289997991409301,11.749998038330078L10.289997991409301,10.199998038330078C12.020207991409302,9.209688038330079,12.865887991409302,7.177868038330078,12.349297991409301,5.2523880383300785C11.832707991409302,3.326908038330078,10.083557991409302,1.991258858330078,8.089997991409302,2.000000000030078ZM9.8099979914093,9.359998038330078L9.319997991409302,9.639998038330077L9.319997991409302,11.209998038330077L6.859997991409301,11.209998038330077L6.859997991409301,9.639998038330077L6.379997991409302,9.359998038330078C4.533130991409302,8.293708038330077,4.096670991409302,5.818418038330078,5.467467991409302,4.184768038330079C6.838267991409301,2.5511200383300783,9.351737991409301,2.5511200383300783,10.722537991409302,4.184768038330079C12.093327991409302,5.818428038330078,11.656867991409301,8.293708038330077,9.8099979914093,9.359998038330078Z"
              fill="currentColor"
            />
          </g>
          <g>
            <path
              d="M14,16L2,16C0.89543,16,0,15.1046,0,14L0,2C0,0.89543,0.89543,0,2,0L14,0C15.1046,0,16,0.89543,16,2L16,14C16,15.1046,15.1046,16,14,16ZM2,1C1.44772,1,1,1.44772,1,2L1,14C1,14.5523,1.44772,15,2,15L14,15C14.5523,15,15,14.5523,15,14L15,2C15,1.44772,14.5523,1,14,1L2,1Z"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutDatax3',
} as DefineComponent
</script>
